import React from 'react';
import { GoogleMap, useLoadScript, Marker } from '@react-google-maps/api';
import styled from 'styled-components';

const StyledMapContainer = styled.div`
  width: 100%;
  height: 400px;
`;

const defaultMapsProps = {
    zoom: 8,
    center: {
        lat: -23.533773,
        lng: -46.62529,
    },
};

function MapContainer(props) {
    const { regionData } = props;

    const { isLoaded, loadError } = useLoadScript({
        googleMapsApiKey: 'AIzaSyBIxPpMpwjA8slB_vDyhBQeW08KO9dJ3Tk',
        // ... outras opções de configuração, se necessário
    });

    const mapRef = React.useRef();
    const onMapLoad = React.useCallback((map) => {
        mapRef.current = map;
    }, []);

    if (loadError) return <div>Erro ao carregar o mapa.</div>;
    if (!isLoaded) return <div>Carregando o mapa...</div>;

    return (
        <StyledMapContainer>
            <GoogleMap
                mapContainerStyle={{
                    height: '400px',
                    width: '100%',
                }}
                zoom={defaultMapsProps.zoom}
                center={defaultMapsProps.center}
                onLoad={onMapLoad}
            >
                {regionData.map((element, index) => {
                    if (!element.latitude && !element.longitude) {
                        return null;
                    }
                    return (
                        <Marker
                            key={index}
                            position={{
                                lat: parseFloat(element.latitude.toString().replace(',', '.')),
                                lng: parseFloat(element.longitude.toString().replace(',', '.')),
                            }}
                            title={element.nome}
                        />
                    );
                })}
            </GoogleMap>
        </StyledMapContainer>
    );
}

export default MapContainer;
